export const CREATE_INSTRUMENTS_OPTIONS = 'CONSTANTS/CREATE_INSTRUMENTS_OPTIONS';

export const CREATE_SELECTION_TERMS_OPTIONS = 'CONSTANTS/CREATE_SELECTION_TERMS_OPTIONS';
export const SET_DEFAULT_SELECTION_TERM = 'CONSTANTS/SET_DEFAULT_SELECTION_TERM';
